import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import StoreIcon from '@mui/icons-material/Store';
import StorageIcon from '@mui/icons-material/Storage';
import {List, ShoppingCart} from '@mui/icons-material';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';

const NavbarMobileBottom = () => {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  const navigate = useNavigate();
  const location = useLocation();

  const tabs = isAuthenticated ? [
    {label: 'Market', path: '/market', icon: StoreIcon},
    {label: 'Cart', path: '/cart', icon: ShoppingCart},
    {label: 'On Sale', path: '/on-sale', icon: List},
    {label: 'Database', path: '/database', icon: StorageIcon},
  ] : [
    {label: 'Market', path: '/market', icon: StoreIcon},
    {label: 'Database', path: '/database', icon: StorageIcon},
  ];

  return (
      <nav
          className="
        fixed bottom-0 left-0 right-0 z-50
        bg-light dark:bg-dark
        border-t border-neutral-300 dark:border-neutral-700
        h-[60px] flex items-center justify-around lg:hidden
      "
      >
        {tabs.map((item) => {
          const active = location.pathname === item.path;
          const Icon = item.icon;

          return (
              <button
                  key={item.label}
                  onClick={() => navigate(item.path)}
                  className="relative flex flex-col items-center justify-center w-full group"
              >
                {/* Icon */}
                <Icon
                    className={`
                transition-all
                ${active ? 'text-[#3f51b5]' : 'text-neutral-500 group-hover:text-neutral-400'}
              `}
                    sx={{fontSize: 26}}
                />

                {/* Label */}
                <span
                    className={`
                text-xs mt-1 transition-all
                ${active ? 'text-[#3f51b5] font-semibold' : 'text-neutral-500 group-hover:text-neutral-300'}
              `}
                >
              {item.label}
            </span>

                {/* Active Glow */}
                {active && (
                    <span className="
                absolute inset-0 rounded-md bg-[#3f51b5]/20 blur-xl pointer-events-none
              "></span>
                )}
              </button>
          );
        })}
      </nav>
  );
};

export default NavbarMobileBottom;
